export default {
    okText: 'Ок',
    cancelText: 'Отмена',
};
